import { Record } from "immutable";
import { combineReducers } from "redux";

import { ModalReducer } from "@typings/modals";

import { Viewports } from "@ui/themes/ThemeInterface";

import { AuthState, useAuthReducer } from "@hooks/useAuth";
import {
  LocalisationState,
  useLocalisationReducer,
} from "@hooks/useLocalisation/redux";

import { subscriptionReducer } from "@app/redux/subscription/subscription.reducer";
import { SubscriptionReducer } from "@app/redux/subscription/subscription.typings";

import { bookingReducer, BookingReducer } from "./booking";
import { b2bReducer, B2BReducer } from "./b2b";
import { endOfTenancyReducer, EndOfTenancyReducer } from "./endOfTenancy";
import { profileReducer, ProfileReducer } from "./profile";
import { paymentReducer, PaymentReducer } from "./payment";
import {
  bookingsToValidateReducer,
  BookingsToValidateReducer,
} from "./bookingsToValidate";
import { applyReducer, ApplyReducer } from "./apply";
import { datalayerReducer, DataLayerReducer } from "./datalayer";
import { holidaysReducer, HolidayReducer } from "./holidays";
import { locationsReducer, LocationsReducer } from "./locations";
import { loadingReducer, LoadingReducer } from "./loading";
import { modalsReducer } from "./modals";
import { userOptionsReducer, UserOptionsReducer } from "./userOptions";
import { viewportReducer } from "./viewport";
import {
  serviceLocationReducer,
  ServiceLocationReducer,
} from "./serviceLocation";
import { Jobs2Reducer } from "./jobs2/jobs2.typings";
import { jobs2Reducer } from "./jobs2/jobs2.reducer";
import { ratingReducer, RatingReducer } from "./rating";
import { recapReducer, RecapReducer } from "./recap";
import { giftCardsReducer, GiftCardsReducer } from "./giftCards";

type IStoreKeys = keyof IStore;
export type IStoreValues = IStore[IStoreKeys];

export interface IStore extends AuthState, LocalisationState {
  booking: Record<BookingReducer>;
  b2b: Record<B2BReducer>;
  datalayer: Record<DataLayerReducer>;
  endOfTenancy: Record<EndOfTenancyReducer>;
  holidays: HolidayReducer;
  loading: LoadingReducer;
  locations: Record<LocationsReducer>;
  modals: ModalReducer;
  payment: Record<PaymentReducer>;
  profile: Record<ProfileReducer>;
  bookingsToValidate: Record<BookingsToValidateReducer>;
  apply: ApplyReducer;
  userOptions: UserOptionsReducer;
  viewport: Viewports;
  serviceLocation: ServiceLocationReducer;
  subscription: SubscriptionReducer;
  jobs2: Record<Jobs2Reducer>;
  rating: Record<RatingReducer>;
  recap: Record<RecapReducer>;
  giftCards: Record<GiftCardsReducer>;
}

export const appReducers = {
  ...useAuthReducer,
  ...useLocalisationReducer,
  booking: bookingReducer,
  b2b: b2bReducer,
  datalayer: datalayerReducer,
  endOfTenancy: endOfTenancyReducer,
  holidays: holidaysReducer,
  loading: loadingReducer,
  locations: locationsReducer,
  modals: modalsReducer,
  payment: paymentReducer,
  profile: profileReducer,
  bookingsToValidate: bookingsToValidateReducer,
  apply: applyReducer,
  userOptions: userOptionsReducer,
  viewport: viewportReducer,
  serviceLocation: serviceLocationReducer,
  subscription: subscriptionReducer,
  jobs2: jobs2Reducer,
  rating: ratingReducer,
  recap: recapReducer,
  giftCards: giftCardsReducer,
};

export default combineReducers(appReducers);
